import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumBold,
    CustomLabelMediumRegular,
    CustomLabelMediumSmallBold
} from "../../common/CustomLabel";

import React from "react";

const HeroSection = ({title, tag, desc, img}) => {

    return (
        <>
        <Grid item container justifyContent={"space-between"}
                    sx={{px :{ xs: 2, md: 8}, marginTop: {xs: "10px", md: "40px"}}}>

                    <Grid item xs={12} md={6} sx={{marginTop: {xs: "20px", lg: "0px"}}}>
                            <Grid item
                                sx={{padding: {xs:"10px",md:"20px 20px"}}}>
                                <Grid item container sx={{marginTop: {xs: "20px", md: "50px"}, textAlign: { xs: "center", md: "left" }}}>
                                        <CustomLabelMediumBold component={"h1"}  textAlign={"left"} text={title} color={"#5E17EB"}/>
                                </Grid> 
                                <Grid item container>
                                        <CustomLabelMediumSmallBold text={tag}/>
                                </Grid> 
                                <Grid item container style={{marginTop: "10px"}}>
                                    <CustomLabelMediumRegular
                                        normal={true}
                                        text={desc}
                                    >
                                    </CustomLabelMediumRegular>
                                </Grid>

                            </Grid>
                    </Grid>


                    <Grid item xs={12} md={6}  
                        sx={{
                            display: {xs: 'none', md: 'flex'},
                            marginTop : "50px",
                        }}>
                        <Grid container justifyContent={"center"}>
                            <img src={img} alt={title} 
                                style={{
                                    borderRadius: 40,
                                    width: "100%",
                                    height: "auto",
                                    maxWidth: "100%",
                                    objectFit: "cover"
                                }}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sx={{display: {xs: 'flex', lg: 'none'}}}>
                        <img src={img} style={{width: "100%"}} alt={title}/>
                    </Grid>

                </Grid>
        </>
    )
}


export default HeroSection;
